import { Observable } from "rxjs";

export abstract class DetalheProcesso {
  abstract getDetalhe(pestab: string, pordem: string): Observable<any>;
}
